/**
 * @file 読書の候補一覧の、段階ごとの目安 (何歳・何年生あたりか)。
 *
 * @what: 出典が公表している「段階 → 年齢のおおよその目安」を写したもの。出典ごとに
 *   語彙も刻みも違うので、series_id で引く。
 * @why: 段階の記号 (5A / 2A) だけでは何歳あたりの本か分からない (代表 2026-08-28)。
 *   カタログ本体は出典から機械で起こすため目安を持たず、ここは出典が別に公表している
 *   説明を写す場所として web 側に置く。
 * @failure: 知らない出典・知らない段階は目安を出さない (推測で埋めない)。出典が段階ごとの
 *   年齢を公表していない場合も、勝手に細かく刻まない。
 */

/**
 * くもんのすいせん図書の目安。
 *
 * 出典の原文: 「5A〜2Aは乳・幼児、A〜Cは低学年、D〜Fは高学年、G〜I は中学以上を、
 * 年齢のおおよその目安にしています。」(公文教育研究会「くもんのすいせん図書」)
 *
 * @why: 出典は段階ごとの年齢まで刻んでいないので、こちらも刻まない。同じ「乳幼児」の中の
 *   易しさの違いは、段階が 5A から順に並んでいること自体が示す。
 */
const KUMON_SUISEN_AUDIENCE: Record<string, string> = {
  "5A": "乳幼児",
  "4A": "乳幼児",
  "3A": "乳幼児",
  "2A": "乳幼児",
  A: "小学校低学年",
  B: "小学校低学年",
  C: "小学校低学年",
  D: "小学校高学年",
  E: "小学校高学年",
  F: "小学校高学年",
  G: "中学以上",
  H: "中学以上",
  I: "中学以上",
};

const AUDIENCE_BY_SERIES: Record<string, Record<string, string>> = {
  "kumon-suisen": KUMON_SUISEN_AUDIENCE,
};

/** その段階が何歳あたりの目安かを返す。分からなければ null (推測で埋めない)。 */
export function levelAudience(seriesId: string, level: string): string | null {
  return AUDIENCE_BY_SERIES[seriesId]?.[level] ?? null;
}

/** 段階の並びが易しい順であることを知らせる 1 行。目安が分かる出典にだけ出す。 */
export function levelOrderHint(seriesId: string, levels: readonly string[]): string | null {
  if (!AUDIENCE_BY_SERIES[seriesId] || levels.length < 2) return null;
  return `${levels[0]} から ${levels[levels.length - 1]} へ、やさしい順に並んでいます。`;
}
